'use strict';

exports.__esModule = true;
exports['default'] = wrapActionCreators;

var _redux = require('redux');

function wrapActionCreators(actionCreators) {
  return function (dispatch) {
    return _redux.bindActionCreators(actionCreators, dispatch);
  };
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-redux/lib/utils/wrapActionCreators.js
// module id = 1949
// module chunks = 0